module.exports = __webpack_public_path__ + "img/icon-park_telegram.1dc08cbc.svg";